import React, { useState, useEffect } from 'react'
import { Col, Container, Row } from "react-bootstrap";
import Modal from 'react-modal'
import Sidebar from "../../Components/Sidebar";
import Header from "../../Components/Header";
import ReactDatatable from "@ashvin27/react-datatable";
import { toastAlert } from "../../lib/toastAlert";
import config from "../../lib/config"
import moment from 'moment';
import { useNavigate, useParams } from 'react-router-dom';
import isEmpty from '../../lib/isEmpty';
import { getCMSlist, updatecms1 } from '../../actions/users';

const customStyles1 = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        border: 'solid',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
    },
    overlay: {
        zIndex: '2'
    }
};

const CmsNewadd = () => {
    const navigate = useNavigate()
    const { name } = useParams();
    const [userdet, setUser] = useState();
    const [userdet1, setUser1] = useState();
    const [selectdet, setselect] = useState({});
    const [subsecimage, setsubsecimage] = useState("");
    const [modalshow, setmodalshow] = useState(false)
    const [file, setfile] = useState()
    const [Title, setTitle] = useState('')

    useEffect(() => {
        if (!isEmpty(selectdet))
            setmodalshow(true)
    }, [selectdet])

    useEffect(() => {
        getMidCMS()
    }, []);

    const handleFile = (e) => {
        e.preventDefault();
        var validExtensions = ["png", 'gif', 'webp', 'PNG', 'jpg', 'jpeg', 'GIF', 'JPEG', 'JPG']; //array of valid extensions
        if (e.target && e.target.files) {
            var reader = new FileReader()
            var file = e.target.files[0];
            setfile(file)
            var fileName = file.name;
            selectdet.Image = `${config.API_URL}/admin/midcms/${selectdet.Id}/${fileName}`
            var fileNameExt = fileName.substr(fileName.lastIndexOf('.') + 1);
            if (!validExtensions.includes(String(fileNameExt))) {
                toastAlert("error", "Only these file types are accepted : " + validExtensions.join(', '));
                return false;
            }
            const fileSize = file.size;
            if (15000000 < fileSize) {
                toastAlert("error", "File size exceeds 15 MB");
                return false;
            }
            else {
                var url = reader.readAsDataURL(file);
                reader.onloadend = function (e) {
                    if (reader.result) {
                        setsubsecimage(reader.result);
                    }
                }.bind(this);
            }
        }
    };

    const columns = [
        {
            key: "Id",
            text: "Id",
            className: "Name",
            align: "center",
            sortable: false,
            cell: (record) => (
                <p className='text-center exchange_table_values'>{record.Id}</p>
            )
        },
        {
            key: "Image",
            text: "Image",
            className: "Name",
            align: "center",
            sortable: false,
            cell: (record) => {
                return (
                    <div className='text-center exchange_table_values'>
                        <img src={record.Image} style={{ width: '100px' }} />
                    </div>
                )
            }
        },

        {
            key: "action",
            text: "Action",
            className: "action",
            width: 100,
            align: "center",
            sortable: false,
            cell: (record) => {
                return (
                    <div className='text-center exchange_table_values'>
                        <button
                            className="btn btn-info btn-sm mr-1"
                            onClick={() => setselect(record)}
                        >
                            <i className="fa fa-edit"></i> Edit
                        </button>
                    </div>
                );
            },
        },
    ];

    const configdata = {
        page_size: 5,
        length_menu: [10, 20, 50],
        filename: "Users",
        no_data_text: "No user found!",

        language: {
            length_menu: "Show _MENU_ result per page",
            filter: "Filter in records...",
            info: "Showing _START_ to _END_ of _TOTAL_ records",
            pagination: {
                first: "First",
                previous: <> Previous </>,
                next: <>Next</>,
                last: "Last",
            },
        },
        show_length_menu: true,
        show_filter: true,
        show_pagination: true,
        show_info: true,
        defaultSortAsc: true,
    };

    const getMidCMS = async () => {
        var test = await getCMSlist({ userId: name });
        test.userValue[0].answer = JSON.parse(test.userValue[0].answer)
        if (test.Success) {
            setUser1(test.userValue[0])
            setUser(test.userValue[0].answer);
            setTitle(test.userValue[0].title)
        }
        else toastAlert("error", "Error on Server");
    };

    const Updatedata = async () => {
        let reqData = {}
        if (!isEmpty(selectdet)) {
            var arr = (userdet).filter((el) => el.Id !== selectdet.Id)
            arr.push(selectdet)
            var check = userdet1
            check.answer = []
            check.answer = JSON.stringify(arr)
            check.title = Title
            reqData = {
                question: check.question,
                answer: check.answer,
                Id: selectdet.Id,
                title: Title,
                Photofile: (file) ? file : "",
                name: (file) ? file.name : ""
            };
        }
        else {
            var check = userdet1
            check.answer = JSON.stringify(userdet1.answer)
            check.title = Title
            reqData = {
                title: check.title,
                answer: check.answer,
                question: check.question
            }
        }
        var mid = true
        var { error } = await updatecms1(reqData, mid)
        if (isEmpty(error)) {
            toastAlert("success", "CMS updated successfully");
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    }

    return (
        <>
            <Container fluid className="common_bg position-relative">
                <div className="liner"></div>
                <Row>
                    <Col xl={2} lg={0} className='p-0 d-none d-xl-block'>
                        <Sidebar />
                    </Col>
                    <Col xl={10} lg={12}>
                        <Header title={'Token List'} />

                        <div className="common_page_scroller mt-5 pe-2">
                        <div>
                              <button className='btn addcate' onClick={()=>navigate(-1)}>Back</button>
                            </div>
                            <div className="page_header">
                                <h2>Midsec</h2>
                            </div>
                            <div>
                                <label htmlFor="Desc" className='mb-2'>Edit Title</label>
                                <input
                                    type="text"
                                    className='form-control'
                                    id="Desc"
                                    value={Title}
                                    onChange={(e) => setTitle(e.target.value)}
                                    style={{ width: '100%' }}
                                />
                                <button
                                    className="btn addcate px-2 py-2 mt-3 mb-3"
                                    onClick={() => Updatedata()}
                                >
                                    <i className="fa fa-edit"></i> Update
                                </button>
                            </div>
                            <div className="exchange_table_holder dashboard_box rounded-3 mt-4">
                                <ReactDatatable
                                    config={configdata}
                                    records={userdet}
                                    columns={columns}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
            <Modal
                isOpen={modalshow}
                style={customStyles1}
                contentLabel="Example Modal"
            >
                {console.log(modalshow,"loop")
                }
                <div className='text-end mb-2'>
                    <button onClick={() => { setmodalshow(false);setselect({}) }} className="closebtns"><i class="fa fa-times"></i></button>
                </div>
                {!isEmpty(userdet1) &&
                    <div>
                        <div className='newthememodal'>
                            <div>
                                <form
                                    noValidate
                                >
                                    <div color="primary" className="addcategorys">
                                        <h4>Update Section</h4>
                                    </div>

                                    <div className="text-center p-5 upload_square">
                                        <img id="subsecimage" src={(subsecimage) ? subsecimage : selectdet.Image} style={{ width: "100px" }} />
                                    </div>

                                    <div className='d-flex'>

                                        <div className="addcateimages pos">
                                            <button className="btn addcate px-2 py-2">Choose Image</button>
                                            
                                                <input
                                                    className="mt-0"
                                                    type="file"
                                                    id="Photofile"
                                                    onChange={handleFile}
                                                />
                                           
                                        </div>

                                        <div className='mt-0'>
                                            <button type='button' className="btn addcate px-2 py-2" onClick={() => Updatedata()}>
                                                Update
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                }
            </Modal>
        </>
    )
}

export default CmsNewadd